import API from "@/API";
import themes from "@/DATA/themes";
import {commit, value} from "lodash/seq";
import dispatch from "alpinejs";
import utils from "@/utils";

const fragmentName = (name) => {
    if( typeof name === 'string' ){
        name = {stage: null, name};
    }else if( Array.isArray( name ) ){
        name = {stage: name[0], name: name[1]};
    }

    if( Array.isArray( name.name ) ){
        name.name = name.name.join('_');
    }

    return name.stage ? `stage_${name.stage}_${name.name}`: name.name;
}

export default {

    namespaced: true,

    state(){
        return {

            is_ready: false,

            canvas: {},

            path_data: {},

            repos: {
                path: {
                    scope: {name: API.fragments.SCOPE_LEARNING_PATH, id: null},
                },
                canvas: {
                    scope: {name: API.fragments.SCOPE_CANVAS, id: null /*this.canvas.id*/},
                },
            },
        };
    },

    getters: {

        canvas2_is_ready(state){
            return state?.is_ready;
        },

        published_canvas_stages(state, getters){
            if( getters._$$canvas.hasOwnProperty('published_stages') ){
                return getters._$$canvas['published_stages'];
            }
            return [];
        },

        _$$canvas_repo(state){
            return state?.repos?.canvas;
        },

        _$$path_repo(state){
            return state?.repos?.path;
        },

        _$$canvas(state, getters){
            return getters?._$$canvas_repo?.fragments;
        },

        _$$path(state, getters){
            return getters?._$$path_repo?.fragments;
        },

        canvas(state){
            return state.canvas;
        },

        project(state){
            return state?.canvas?.project;
        },

        team(state){
            return state?.canvas?.team;
        },

        stages(state, getters){
            const stages = getters._$$path?.stages?.map(slug => ({
                slug,
                config: getters.getPathFragment({stage: slug, name: 'config'})
            }));
            return stages ? stages : [];
        },

        goal(state, getters){
            return themes.reduce((prev, val) => val.id == getters.project?.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'})
        },

        uuid(state){
            return state.canvas.uuid;
        },

        getPathFragment: (state, getters) => (...args) => {
            const name = fragmentName(...args);
            // console.log({name, args});
            return typeof getters._$$path[ name ] === 'undefined' ? null : getters._$$path[ name ];
        },

        getCanvasFragment: (state, getters) => (...args) => {
            const name = fragmentName(...args);
            return getters._$$canvas[ name ] ?? null;
        },

        getPathData: (state) => (key) => {
             return state.path_data[ key ] ? state.path_data[ key ] : null;
        },

        getStageMissionDetails: (state, getters) => (stage) => {
            return getters.getPathFragment({stage, name: 'misson_details'});
        },

        getPathActivitiesAndResourcesByStage: (state, getters) => (stage) => {
            return getters.getPathData(`activities_${stage}`) ?? [];
        },

        getPathActivitiesAndResourcesSectionsByStage: (state, getters) => (stage) => {
            return getters.getPathFragment({stage, name: `activity_sections`}) ?? [];
        },

        getPodcastsOnlyByStage: (state, getters) => (stage) => {
            const sections = getters.getPathActivitiesAndResourcesByStage(stage);
            if( !sections.length ) return [];

            const podcasts = [];

            for( let i = 0; i < sections.length; i++ ){

                const section = sections[ i ];

                for( let j = 0; j < section.activities.length; j++ ){

                    const item = section?.activities[ j ]?.activity;

                    if( item?.type === 'resource' && item?.data?.type === 'podcast' ) {

                        const key = `stage_${stage}_${section.id}_podcast_${section.activities[ j ]?.id}`;
                        const content = getters._$$path[ key ];

                        const podcast = {
                            section_id: section.id,
                            ...section.activities[ j ],
                            ...content,
                        };
                        podcasts.push(podcast);
                    }
                }
            }

            return podcasts;
        },

        getPathActivitiesOnlyByStage: (state, getters) => (stage) => {
            const sections = getters.getPathActivitiesAndResourcesByStage(stage);
            if( !sections.length ) return [];

            const activities = [];
            for( let i = 0; i < sections.length; i++ ){
                for( let j = 0; j < sections[ i ].activities.length; j++ ){
                    if( sections[ i ].activities[ j ].activity.type !== 'activity' ) continue;
                    activities.push({
                        section_id: sections[i].id,
                        ...sections[ i ].activities[ j ],
                    })
                }
            }

            return activities;
        },

        getAllActivities: (state, getters) => {
            let activities = [];
            getters.stages.map(s => activities = activities.concat( getters.getPathActivitiesOnlyByStage( s.slug ) ) );
            return activities;
        },

        getPathActivitiesWithoutCanvasUploadsByStage: (state, getters) => (stage) => {

            const activities = getters.getPathActivitiesOnlyByStage( stage );
            const uploads = getters.getAllCanvasActivityUploadsByStage( stage );

            return activities.filter( a => uploads.filter(u => u.activity_id === a.id).length === 0 );
        },

        getCanvasActivityUploadsBySection: (state, getters) => (stage, section_id) => {
            const key = `canvas_upload_${stage}_${section_id}`;
            return getters._$$canvas[ key ] ?? [];
        },

        getAllCanvasActivityUploadsByStage: (state, getters) => (stage) => {
            const sections = getters.getPathActivitiesAndResourcesSectionsByStage(stage);
            let uploads = [];
            sections.map( s => uploads = uploads.concat( getters.getCanvasActivityUploadsBySection( stage, s.id ) ) );
            return uploads;
        },

        getActivityById: (state, getters) => (activity_id) => {
            console.log({ACTIVITIES: getters.getAllActivities, activity_id});
            return getters.getAllActivities.find( a => a.id === activity_id ) ?? null;
        },

        getSectionIdByActivityId:  (state, getters) => (activity_id, stage) => {
            console.log({ACTIVITY: getters.getActivityById(activity_id)});
            if( activity_id ){
                const activity = getters.getActivityById( activity_id ) ?? null;
                if( activity ) return activity.section_id;
            }
            if( !stage ) return null;
            const sections = getters.getPathActivitiesAndResourcesSectionsByStage(stage);
            console.log({stage, sections});
            return sections.length ? sections[0].id : null;
        },

        getCanvasStageCover:(state, getters) => (stage_name) => {
            return getters._$$canvas[ `${stage_name}_cover` ] ?? {
                image: null,
                text: '',
            };
        },

        getCanvasDeliverable:(state, getters) => (stage_name) => {
            return getters._$$canvas[ `stage_${stage_name}_mission_deliverable` ] ?? {
                file: null,
                text: '',
            };
        }

    },

    mutations: {

        setCanvas(state, {canvas}){
            state.canvas = canvas;
            state.repos.canvas.scope.id = canvas.id;
            state.repos.path.scope.id = canvas.project.learning_path_id;
        },

        setRepo(state, {name, repo}){
            state.repos[ name ] = repo;
        },

        setReady(state, is_ready){
            state.is_ready = is_ready;
        },

        setPathData(state, {key, value}){
            state.path_data[ key ] = value;
        },



    },


    actions: {

        /**
         *
         * @param state
         * @param commit
         * @param dispatch
         * @param canvas
         * @returns {Promise<void>}
         */
        async initCanvas({state, commit, dispatch}, canvas){

            commit('setCanvas', {canvas});

            await dispatch('loadAllRepos');
            await dispatch('loadAllActivities');

            commit('setReady', true);
        },


        /**
         *
         * @param state
         * @param commit
         * @param dispatch
         * @returns {Promise<void>}
         */
        async loadAllRepos({state, commit, dispatch}){
            for( const repo_name in state.repos ){
                if( !state.repos.hasOwnProperty( repo_name ) ) continue;
                const repo = (await dispatch('repositories/getRepository', state.repos[ repo_name ].scope, {root: true}));
                commit('setRepo', {name: repo_name, repo});
            }
        },


        /**
         *
         * @param commit
         * @param getters
         * @param stage
         * @returns {Promise<void>}
         */
        async loadActivitiesByStage({commit, getters}, stage){

            let sections = getters.getPathFragment({stage, name: 'activity_sections'});
            if( !sections ) return;

            const key = `activities_${stage}`;

            // Check if data has already been fetched, we don't need to re-fetch again.
            // TODO: Check if one fetch is good enough in all cases and we are not missing with any stale data.
            if( getters._$$path[ key ] ?? false ) return;

            let activity_ids = [];
            sections = sections.map(s => {
                let activities = getters.getPathFragment({stage, name: ['combined_activities', s.id]});
                if( !activities ) activities = [];
                activity_ids = activity_ids.concat( activities.map(a => a.v) )
                return { ...s, activities}
            });

            // TODO: Cache activities data in storage for multiple call from various stages.

            const activities_data = await API.elements.bulk({ids: activity_ids});
            const activities_data_obj = {};
            activities_data.map(a => activities_data_obj[ a.id ] = a);

            sections.map(s => {
                s.activities.map(a => a.activity = activities_data_obj[ a.v ]);
            });

            commit('setPathData', {key, value: sections});
        },

        async loadAllActivities({state, commit, dispatch, getters}){
            const stages = getters.stages;
            for( let i = 0; i < stages.length; i++ ){
                const activities = await dispatch('loadActivitiesByStage', stages[i].slug);
                commit('setPathData', {key: `activities_${state.slug}`, activities});
            }
        },

        async setCanvasStageCover({state, commit, dispatch, getters}, {stage, image, text}){
            const stage_name = stage.slug ?? stage;

            const cover = getters.getCanvasStageCover(stage_name);
            console.log({cover});

            cover.image = image ?? cover.image;
            cover.text = text ?? cover.text;

            console.log({cover});

            const updates = {[`${stage_name}_cover`]: cover};
            await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments: updates}, {root: true});
        },

        async setCanvasDeliverable({state, commit, dispatch, getters}, {stage, file, text}){
            const stage_name = stage.slug ?? stage;

            const deliverable = getters.getCanvasDeliverable(stage_name);
            console.log({deliverable});

            deliverable.file = file ?? deliverable.file;
            deliverable.text = text ?? deliverable.text;

            console.log({deliverable});

            const updates = {[`stage_${stage_name}_mission_deliverable`]: deliverable};
            await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments: updates}, {root: true});
        },


        /**
         *
         * @param state
         * @param dispatch
         * @param repo
         * @param stage
         * @param fragments
         */
        async pushFragments({state, dispatch}, {repo, stage, fragments}){
            const updates = {};
            const keys = Object.keys(fragments);
            for( let i = 0; i < keys.length; i++ ) {
                const name = keys[i];
                const f_name = fragmentName({stage, name});
                updates[f_name] = fragments[keys[i]];
            }


            if( keys.length ){
                await dispatch('repositories/updateRepository', {scope: state.repos[repo].scope, fragments: updates}, {root: true});
            }

        },


        /**
         * @param dispatch
         * @param stage
         * @param fragments
         * @returns {Promise<void>}
         */
        async pushCanvasFragments({dispatch}, {stage, fragments}){
            await dispatch('pushFragments', {repo: 'canvas', stage, fragments});
        },


        /**
         * @param dispatch
         * @param stage
         * @param fragments
         * @returns {Promise<void>}
         */
        async pushPathFragments({dispatch}, {stage, fragments}){
            await dispatch('pushFragments', {repo: 'push', stage, fragments});
        },


        async addActivityUploadOnCanvas({dispatch, state, getters}, {stage, activity_id, file, options}){
            const section_id = getters.getSectionIdByActivityId(activity_id, stage);
            console.log({stage, activity_id, section_id});
            const key = `canvas_upload_${stage}_${section_id}`;

            let uploads = getters.getCanvasFragment(key);
            if( !uploads ) uploads = [];

            uploads.push({
                id: utils.randomId({prefix: 'file'}),
                file,
                activity_id,
                options
            });

            const fragments = {[ key ]: uploads};
            console.log({uploads, fragments});

            await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});

            // TODO: After uploading check the integrity of state.

            return uploads;
        },

        async syncUploadsOnCanvas({dispatch, state, getters}, {stage, uploads}){
            const section_id = getters.getSectionIdByActivityId(null, stage);
            const fragments = {[`canvas_upload_${stage}_${section_id}`]: uploads};
            await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});
            return uploads;
        },

        async removeActivityUploadOnCanvas({dispatch, state, getters}, upload_id){
            const stages = getters.stages;

            for( let i = 0; i < stages.length; i++ ){
                const stage = stages[i];
                const sections = getters.getPathActivitiesAndResourcesSectionsByStage(stage.slug);

                for( let j = 0 ; j < sections.length; j++ ){
                    const section = sections[j];
                    const uploads = getters.getCanvasActivityUploadsBySection(stage.slug, section.id);
                    const index = uploads.findIndex(u => u.id === upload_id);

                    if( index >= 0 ){
                        const deleted = uploads.splice(index, 1);
                        const key = `canvas_upload_${stage.slug}_${section?.id}`;
                        const fragments = {[key]: uploads};
                        await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});
                        return deleted;
                    }

                }
            }

            return null;

        },

        async setActivityUploadOptions({dispatch, state, getters}, {upload_id, options}){
            const stages = getters.stages;

            for( let i = 0; i < stages.length; i++ ){
                const stage = stages[i];
                const sections = getters.getPathActivitiesAndResourcesSectionsByStage(stage.slug);

                for( let j = 0 ; j < sections.length; j++ ){
                    const section = sections[j];
                    const uploads = getters.getCanvasActivityUploadsBySection(stage.slug, section.id);
                    const index = uploads.findIndex(u => u.id === upload_id);

                    if( index >= 0 ){

                        if( typeof uploads[ index ].options === 'undefined' ){
                            uploads[ index ].options = {};
                        }

                        uploads[ index ].options = _.extend({}, uploads[ index ].options, options);

                        const key = `canvas_upload_${stage.slug}_${section?.id}`;
                        const fragments = {[key]: uploads};
                        await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});
                    }

                }
            }
        },


        /**
         * Publish a canvas stage.
         * @param dispatch
         * @param state
         * @param getters
         * @param stage
         * @returns {Promise<void>}
         */
        async publishCanvasStage({dispatch, state, getters}, stage){
            if( getters.published_canvas_stages.indexOf(stage.slug) < 0 ){
                getters.published_canvas_stages.push( stage.slug );
                const fragments = {['published_stages']: getters.published_canvas_stages};
                await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});
            }
        },

        /**
         * Publish a canvas stage.
         * @param dispatch
         * @param state
         * @param getters
         * @param stage
         * @returns {Promise<void>}
         */
        async unPublishCanvasStage({dispatch, state, getters}, stage){
            console.log(getters.published_canvas_stages);
            const idx = getters.published_canvas_stages.indexOf(stage.slug);
            if( idx >= 0 ){
                getters.published_canvas_stages.splice( idx, 1 );
                const fragments = {['published_stages']: getters.published_canvas_stages};
                await dispatch('repositories/updateRepository', {scope: state.repos.canvas.scope, fragments}, {root: true});
            }
        },

    },


}

